import React from "react";
import { Button } from "@design-system/Button/Button";
import { HStack } from "@design-system/HStack/HStack";

interface Props {
    message: string;
    onMerge?: () => void;
}

export const ReassignRoleSuccessToast: React.FC<Props> = ({
    message,
    onMerge,
}) => (
    <HStack gap={12} align="center" wrap>
        <span>{message}</span>
        {onMerge ? (
            <Button
                type="button"
                variant="secondary"
                size="sm"
                onClick={onMerge}
            >
                Merge
            </Button>
        ) : null}
    </HStack>
);
